import type { ContactFormBlockProps } from '../types';
import { theme, sectionColors } from '../theme';

/**
 * Contact form. Server-safe (no "use client"): a plain POST form to the tenant
 * site's same-origin `/api/lead` route, which forwards the lead to the gateway and
 * redirects back with `?contact=sent|error` (the host passes that here as
 * `submitState`). The lead destination is resolved server-side per tenant — never
 * hardcoded in the block (CLAUDE.md non-negotiable #2).
 */
export function ContactFormBlock(
  props: ContactFormBlockProps & { submitState?: 'sent' | 'error' },
) {
  const { heading = 'Contact', showPhone = true, submitState } = props;
  const colors = sectionColors(props, { bg: 'transparent', text: theme.text });
  const field = 'w-full rounded-md border border-black/15 bg-transparent px-3 py-2';
  return (
    <section id="contact" className="px-6 py-12" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <div className="mx-auto max-w-xl">
        <h2 className="mb-6 text-2xl font-semibold" style={{ fontFamily: theme.headingFont }}>{heading}</h2>
        {submitState === 'sent' ? (
          <p className="mb-4 rounded-md bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
            Thanks! Your message has been sent — we’ll be in touch soon.
          </p>
        ) : null}
        {submitState === 'error' ? (
          <p className="mb-4 rounded-md bg-red-50 px-4 py-3 text-sm text-red-700">
            Sorry, something went wrong sending your message. Please try again.
          </p>
        ) : null}
        <form action="/api/lead" method="post" className="space-y-4">
          <input type="text" name="name" placeholder="Your name" required className={field} />
          <input type="email" name="email" placeholder="you@example.com" required className={field} />
          {showPhone ? <input type="tel" name="phone" placeholder="Phone (optional)" className={field} /> : null}
          <textarea name="message" placeholder="How can we help?" rows={4} className={field} />
          <button type="submit" className="rounded-md px-6 py-2 font-medium text-white hover:opacity-90" style={{ backgroundColor: theme.primary }}>Send</button>
        </form>
      </div>
    </section>
  );
}
